var React = require('react');

function UserGrid2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.15","fillRule":"evenodd","clipRule":"evenodd","d":"M300.507 560.066C245.552 564.594 201.306 523.822 157.425 490.431C123.4 464.539 94.9619 433.822 81.3432 393.293C67.4256 351.875 72.4072 309.737 82.4151 267.205C97.4849 203.16 91.1742 114.51 152.53 90.7564C213.583 67.1205 262.279 147.422 321.887 174.495C388.472 204.737 484.616 190.274 516.525 256.078C549.175 323.41 506.227 404.26 462.881 465.259C425.14 518.37 365.442 554.715 300.507 560.066Z","fill":"#709BE7"}));
}

UserGrid2.defaultProps = {"width":"587","height":"613","viewBox":"0 0 587 613","fill":"none"};

module.exports = UserGrid2;

UserGrid2.default = UserGrid2;
